import WallEntity from '@/editor/entities/wallEntity';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

export class WallManager {
  private _list: WallEntity[] = [];

  constructor() {}

  private getDataList() {
    const wallHiddenIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.Wall);
    return globalStores.wallStore.getWallDatas().filter((data) => !wallHiddenIds.has(data.id));
  }

  update() {
    const newWallDatas = this.getDataList();
    const newWallDataMap = new Map(newWallDatas.map((data) => [data.id, data]));

    for (let i = this._list.length - 1; i > -1; i--) {
      const entity = this._list[i];
      const newWallData = newWallDataMap.get(entity.id);
      if (newWallData) {
        entity.update(newWallData);
      } else {
        this.deleteEntity(i);
      }

      newWallDataMap.delete(entity.id);
    }

    // 添加新数据
    for (const wallData of newWallDataMap.values()) {
      const wallEntity = new WallEntity(wallData.id);
      wallEntity.update(wallData);
      this.addEntity(wallEntity);
    }
  }

  private addEntity(wallEntity: WallEntity) {
    this._list.push(wallEntity);
  }

  private deleteEntity(index: number) {
    this._list[index]?.dispose();
    this._list.splice(index, 1);
  }

  getWallEntity(id: string) {
    for (const entity of this._list) {
      if (id === entity.id) return entity;
    }
  }

  updateVisible(_v: boolean, _ids: string[]) {}
}
